let initialised = false;

function ensureOverlays(): { preview: HTMLElement; lb: HTMLElement } {
  let container = document.getElementById("media-overlays");
  if (!container) {
    container = document.createElement("div");
    container.className = "ads-refresh";
    container.id = "media-overlays";
    container.innerHTML =
      '<div class="media-preview" id="media-preview"><img src="" alt=""></div>' +
      '<div class="media-lb" id="media-lb">' +
      '<div class="media-lb-inner">' +
      '<span class="media-lb-close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></span>' +
      '<img src="" alt="">' +
      '<div class="play-big"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></div>' +
      '<div class="media-lb-cap"></div>' +
      "</div></div>";
    document.body.appendChild(container);
  }
  return {
    preview: document.getElementById("media-preview") as HTMLElement,
    lb: document.getElementById("media-lb") as HTMLElement,
  };
}

export function initMediaPreview(): void {
  if (initialised) return; // delegated on document — bind once
  initialised = true;

  const { preview, lb } = ensureOverlays();
  const pImg = preview.querySelector("img") as HTMLImageElement;
  const lbImg = lb.querySelector("img") as HTMLImageElement;
  const lbCap = lb.querySelector(".media-lb-cap") as HTMLElement;
  const lbPlay = lb.querySelector(".play-big") as HTMLElement;
  let cur: HTMLElement | null = null;

  function position(e: MouseEvent) {
    const pad = 16;
    const w = preview.offsetWidth || 270;
    const h = preview.offsetHeight || 200;
    let x = e.clientX + pad;
    let y = e.clientY + pad;
    if (x + w > window.innerWidth) x = e.clientX - w - pad;
    if (y + h > window.innerHeight) y = window.innerHeight - h - 8;
    preview.style.left = x + "px";
    preview.style.top = y + "px";
  }

  function hide() {
    cur = null;
    preview.style.display = "none";
  }

  document.addEventListener("mouseover", (e) => {
    const t = (e.target as HTMLElement).closest(".media-thumb") as HTMLElement | null;
    if (t && t !== cur) {
      cur = t;
      pImg.src = t.dataset.media || "";
      preview.style.display = "block";
      position(e as MouseEvent);
    }
  });

  document.addEventListener("mousemove", (e) => {
    if (!cur) return;
    if (!(e.target as HTMLElement).closest(".media-thumb")) hide();
    else position(e as MouseEvent);
  });

  document.addEventListener("click", (e) => {
    const t = (e.target as HTMLElement).closest(".media-thumb") as HTMLElement | null;
    if (!t) return;
    hide();
    lbImg.src = t.dataset.media || "";
    lbCap.textContent = (t.dataset.title || "") + " · " + (t.dataset.fmt || "");
    lbPlay.style.display = t.dataset.type === "video" ? "grid" : "none";
    lb.classList.add("open");
  });

  lb.addEventListener("click", (e) => {
    if (e.target === lb || (e.target as HTMLElement).closest(".media-lb-close")) {
      lb.classList.remove("open");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") lb.classList.remove("open");
  });
}
